import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M10.6562 4.71875L10.6563 9.09375H15.0313C15.3867 9.09375 15.6875 9.39453 15.6875 9.75C15.6875 10.1328 15.3867 10.4062 15.0313 10.4062H10.6563V14.7812C10.6563 15.1641 10.3555 15.4375 10 15.4375C9.61719 15.4375 9.34375 15.1641 9.34375 14.7812V10.4062L4.96875 10.4062C4.58594 10.4062 4.3125 10.1328 4.3125 9.75C4.3125 9.39453 4.58594 9.09375 4.96875 9.09375H9.34375V4.71875C9.34375 4.36328 9.61719 4.0625 10 4.0625C10.3555 4.0625 10.6562 4.36328 10.6562 4.71875Z"
	})
});
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
